import React, { useRef, useEffect, useCallback, useState} from 'react';
import PianoSlider from './PianoSlider.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {spread} from "pattern/utils/spread.js";
import {connect} from 'react-redux';

const PianoSpreader = ({clear, track, selectedSteps}) => { 
    let stepNumbers = useRef([]);
    let originalSteps = useRef(selectedSteps);
    let mutations = useRef(undefined);
    let stepNumber = useRef(0);

    let [value, setValue] = useState(0);

    useEffect(() => {
        if (!originalSteps.current) { return; }
        stepNumbers.current = track.getEasyPattern().getStepNumbers(originalSteps.current, undefined, true);
    }, []);

    const onChange = useCallback((e) => {
        let _value = e.target.value;
        let _mutations = mutations.current || originalSteps.current;
        mutations.current = spread(track, _mutations, stepNumbers.current, _value);
        setValue(_value);
    }, [track, setValue]);

    return (
        <PianoSlider
          name="Spread"
          value={value}
          min={-8}
          max={8}
          step={0.01}
          onChange={onChange}
        />
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoSpreader);
